import * as React from 'react';
import { generateClassName, hasParentWithClassName } from 'utils';
import { ItemValue } from '../components/SelectRich';
import Layer from '../data/Layer';
import { PropertyTimeline } from '../data/LayerTimeline';
import ActionButton from './components/ActionButton';
import { EffectTimelineAdancedView } from './EffectTimelineAdvancedView';
import { EffectTimelineSimpleView } from './EffectTimelineSimpleView';

export const TIMELINE_RESET = 'TIMELINE_RESET';

interface Props {
  layer: Layer;
  effect: ItemValue;
}

interface State {
  isOpen: boolean;
}

export class EffectTimelineView extends React.Component<Props, State> {
  state: State = {
    isOpen: false
  };

  get timeline(): PropertyTimeline {
    const { layer, effect } = this.props;
    return layer.timeline[effect.id];
  }

  resetTimeline = () => {
    this.timeline.reset();
    this.forceUpdate();
    document.dispatchEvent(new Event(TIMELINE_RESET));
  };

  didChangePoints = () => {
    this.timeline.clean();
    this.forceUpdate();
  };

  doesWantToClose = (e: React.MouseEvent<HTMLDivElement>) => {
    if (hasParentWithClassName(e.target as HTMLElement, 'timeline-controls')) {
      return;
    }
    this.setState({ isOpen: false });
  };

  render() {
    const { layer, effect } = this.props;
    const { isOpen } = this.state;
    const timeline = layer.timeline[effect.id];
    return (
      <div className="effect-timeline">
        <div
          className={generateClassName('effect-timeline-top', { isOpen })}
          onClick={isOpen ? this.doesWantToClose : undefined}
        >
          {!isOpen && (
            <EffectTimelineSimpleView
              layer={layer}
              effect={effect}
              onExpand={() => this.setState({ isOpen: true })}
            />
          )}
          <div className="label">{effect.label}</div>
          {isOpen && (
            <div className="timeline-controls">
              <ActionButton
                onClick={this.resetTimeline}
                disabled={!timeline || !timeline.isCustom()}
              >
                Reset
              </ActionButton>
              <button
                className="tertiary timeline-close-btn"
                onClick={() => this.setState({ isOpen: false })}
              />
            </div>
          )}
        </div>
        {isOpen && (
          <EffectTimelineAdancedView
            layer={layer}
            effect={effect}
            onChange={this.didChangePoints}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/EffectTimelineView.tsx